import type { UnlikelyCollection } from "@unlikelystudio/commerce-connector"

import type { Nullish } from "~/@types/generics"
import type { ShopifyProductFilters } from "~/lib/shopify/types"
import { facetIdToFacetName } from "~/lib/shopify/utils/filter-facets"

export function getDefaultFiltersNames({ defaultFilters }: { defaultFilters: NonNullable<ShopifyProductFilters> }) {
  return (
    defaultFilters
      ?.map((entry) => {
        if (entry?.productMetafield) return entry?.productMetafield?.key
        if (entry?.variantOption) return entry?.variantOption?.name
        return null
      })
      ?.filter(Boolean) ?? []
  )
}

export function productFiltersToFacets({
  defaultFilters,
  filters = [],
}: {
  defaultFilters: NonNullable<ShopifyProductFilters>
  filters: Nullish<UnlikelyCollection["filters"]>
}) {
  const defaultFiltersNames = getDefaultFiltersNames({ defaultFilters })

  return filters
    ?.filter((facet) => {
      const name = facetIdToFacetName(facet)
      return !defaultFiltersNames?.includes(name)
    })
    ?.map((facet) => ({
      ...facet,
      processedName: facetIdToFacetName(facet),
    }))
}
